import * as React from 'react';
// @ts-ignore @types/react-select can't be updated
// eslint-disable-next-line import/named
import { createFilter } from 'react-select';

export const getIsViewPage = () => window.location.search.includes('form_name=view');
export const getIsListingPage = () => window.location.search.includes('form_name=listing');

export const customFilter = createFilter({
  matchFrom: 'any',
  stringify: (option: AutocompleteOption) => `${option.label}`,
});

type CallBackType<T> = (updatedValue: T) => void;
type SetStateType<T> = T | ((prev: T) => T);
type RetType = <T>(
  initialValue: T | (() => T)
) => [T, (newValue: SetStateType<T>, callback?: CallBackType<T>) => void];

export const useCallbackState: RetType = <T>(initialValue: T | (() => T)) => {
  const [state, _setState] = React.useState<T>(initialValue);
  const callbackQueue = React.useRef<CallBackType<T>[]>([]);

  React.useEffect(() => {
    callbackQueue.current.forEach((cb) => cb(state));
    callbackQueue.current = [];
  }, [state]);

  const setState = (newValue: SetStateType<T>, callback?: CallBackType<T>) => {
    _setState(newValue);
    if (callback && typeof callback === 'function') {
      callbackQueue.current.push(callback);
    }
  };
  return [state, setState];
};
